import { Component, OnInit, ViewChild, HostListener, Input } from '@angular/core';
import { SupportDialogComponent } from '../support-dialog/support-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../../../shared';
import { TranslationService } from '../../services/translation.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { Session } from '../../services/session.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationPipe } from '../../pipes/translation.pipe';
import { DisplayService } from '../../services/display-service';

@Component({
    selector: 'app-footer',
    providers: [TranslationPipe],
    template: `<div
      class="footer tw-grow-0 tw-grid tw-grid-cols-1 tw-justify-items-center "
      role="contentinfo"
      >
      <div
        class="tw-flex tw-max-w-screen-xl tw-w-full tw-items-center"
        >
        <div class="tw-grow">
          <img
            src="/assets/images/Sedgwick_Footer_Logo.png"
            width="155"
            height="37"
            loading="lazy"
            class="tw-pr-2 app-pr3 app-uppercase app-pb2 app-pt2"
            style="margin:auto;"
            alt="Sedgwick Logo"
            />
          </div>
          <div
            class="tw-grow-0 tw-pt-2  tw-flex tw-flex-col sm:tw-flex-row tw-gap-1"
            style="margin:auto;"
            >
            <a
              [attr.aria-label]="'Opens Technical Support popup' | translation : translationRequest"
              (click)="openSupportDialog()"
              (keydown.enter)="openSupportDialog()"
              role="button"
              class="app-pr3 app-uppercase app-pb2 app-pt2"
              tabindex="0"
              >{{'TECHNICAL SUPPORT' | translation : translationRequest}}</a
              >
              <a
                label="Site Map"
                routerLink="/sitemap"
                class="app-pr3 app-uppercase app-pb2 app-pt2"
                >{{'Site Map' | translation : translationRequest}}</a
                >
                <a
                  href="https://www.sedgwick.com/privacy"
                  target="privacy-notice"
                  class="app-pr3 app-uppercase app-pb2 app-pt2"
                  >{{'Privacy Policy' | translation : translationRequest}}</a
                  >
                  <a
                    href="https://www.sedgwick.com/termsandconditions"
                    target="privacy-notice"
                    class="app-pr3 app-uppercase app-pb2 app-pt2"
                    >{{'Terms & Conditions' | translation : translationRequest}}</a
                    >
                    @if (display.showHelpLink) {
                      <a
                        href="{{ helpUrl }}"
                        target="privacy-notice"
                        class="app-pr3 app-uppercase app-pb2 app-pt2"
                        >{{'Help' | translation : translationRequest}}</a
                        >
                    }
                      @if (allowMultipleLanguages) {
                        <div class="tw-w-full md:tw-w-auto language-text-alignment tw-uppercase">
                          <button
                            tabindex="0"
                            id="language-open"
                            class="language-button app-pr3 app-uppercase app-pb2 app-pt2"
                            (click)="toogleLanguage()"
                            (keydown)="onLanguageKeydown($event)"
                            [attr.aria-expanded]="showLangMenu"
                            role="button"
                            aria-label="Opens a list of available translation languages"
                            >
                            <div class="button-with-regions">
                              <p class="text-white">{{getSelectedLanguage() | uppercase}}</p>
                            </div>
                            @if (showLangMenu) {
                              <div
                                role="menu"
                                class="regional-menu-is-open regional-nav"
                                >
                                <div class="scrollbar">
                                  <div>
                                    <div class="regional-nav-title-div">
                                      <p tabindex="0" id="languages-tab" class="regional-nav-title">SELECT LANGUAGES</p>
                                    </div>
                                    <ul id="languages-list" class="regional-nav-item-div hide-list">
                                      @for (language of availableLanguages | keyvalue : sortByValue; track language) {
                                        <li
                                          [attr.data-l]="language.key"
                                          class="wg-li weglot-lang weglot-language"
                                          [class.active-item]="selectedLanguageCode === language.key">
                                          <a class="regional-nav-item"
                                            [class.active-item]="selectedLanguageCode === language.key"
                                            role="menuitem"
                                            data-wg-notranslate=""
                                            (click)="selectLanguage(language.key, $event)"
                                            (keydown.enter)="selectLanguage(language.key, $event)"
                                            (keydown.space)="selectLanguage(language.key, $event)"
                                            href="javascript:void(0)">
                                            {{language.value}}
                                          </a>
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            }
                          </button>
                        </div>
                      }
                      <div class="app-pr3 app-uppercase app-pb2 app-pt2">
                        <span>{{ appCompany }}</span>
                      </div>
                    </div>
                  </div>
                </div>`,
    styles: [
        `
      .footer a {
        color: white;
      }

      .footer a:hover {
        color: #ffffff;
        text-decoration: solid underline #ffffff 2px !important;
        cursor: pointer;
      }

      .footer a:focus {
        border: 2px solid black !important;
        outline: 2px solid white !important;
      }

      .footer span {
        color: #ffffff;
        padding: 0 7px 0 7px;
      }

      .language-button {
        position: relative;
        height: 42px;
        border-radius: 0.375rem;
        --tw-bg-opacity: 1;    
        padding-left: 18px;
        padding-right: 18px;
        cursor: pointer;
        font-weight: 700;
        color: var(--sed-warm-white-color);
        background: transparent;
        border: none;
      }
        
      @media (min-width: 1024px) {
        .regional-nav {
            left: unset;
            right: 0px;
          }
        }
      @media (min-width: 640px) {
        .regional-nav {
            width: 200px;
          }
        } 
        .regional-nav{
          position: absolute;
        left: -3.25rem;
        bottom: 30px;
        z-index: 10;
        display: flex;
        width: 100vw;
        max-width: 200px;
        border-radius: 0.375rem;
        border-width: 1px;
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        opacity: 0;
        }
        .regional-menu-is-open {
        bottom: 50px!important;
        z-index: 1000!important;
        opacity: 1!important;
        }
        .scrollbar {
        display: flex;
        flex: 1 1 0%;
        overflow-y: auto;
        scrollbar-color: #00f584 #212121;
        scrollbar-width: thin;
        height: 300px;
        }
        .regional-nav .regional-nav-item-div {
        display: flex;
        height: -moz-fit-content;
        height: fit-content;
        flex-direction: column;
        padding: 0.25rem;
        text-align: start;
        gap: 3px;
        }
        
        #language-open .button-with-regions {
        display: flex;
        cursor: pointer;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
    }

    .language-text-alignment {
      text-align: center;
    }

    @media (max-width: 767px) {
      .language-button {
        padding-right: 0px !important;
        padding-left: 0px !important;
      }

      .language-text-alignment {
        text-align: start;
      }
    }

    .text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    }

    .text-white:hover {
        text-decoration: underline;
        text-decoration-color: rgb(255 255 255 / var(--tw-text-opacity, 1));
        text-decoration-thickness: 2px;
        text-underline-offset: 3px;
    }
    .text-25-fresh-mint {
        --tw-text-opacity: 1;
        color: rgb(0 245 132 / var(--tw-text-opacity, 1));
    }

    .regional-nav-item {
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
        text-decoration: none;
        display: block;
        padding: 0.5rem;
        border-radius: 0.25rem;
        transition: all 0.2s ease;
        border-width: 1px;
        border-color: #000000;
    }

    .regional-nav-item.active-item {
        background-color: rgb(0 245 132 / var(--tw-text-opacity, 1));
        font-weight: 700;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
        border-color: #000000;
        border-width: 1px;
        border-style: solid;
        text-decoration: none;
    }

    /* When hovering over any item in the list, remove active styling from all active items */
    .regional-nav-item-div:hover .regional-nav-item.active-item {
        background-color: transparent;
        font-weight: 700;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
        border-color: #000000;
    }

    /* Then apply hover styles to the specific item being hovered */
    .regional-nav-item-div:hover .regional-nav-item:hover {
        background-color: rgb(0 245 132 / var(--tw-text-opacity, 1));
        font-weight: 700;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
        border-color: #000000;
        border-width: 1px;
        border-style: solid;
    }

    .regional-nav-title{
        --tw-text-opacity: 1;
        color: rgb(250 250 250 / var(--tw-text-opacity, 1));
        text-decoration-line: underline;
        text-decoration-color: #ffffff;
        text-decoration-thickness: 9%;
        text-underline-offset: 3.5px;
        font-weight: 700;
    }
    `,
    ],
    standalone: false
})
export class FooterComponent extends BaseComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @Input()
    translationRequest: TranslationRequest;

  appCompany: string = '© #YEAR SEDGWICK';
  helpUrl: string;
  development = false;
  selectedLanguageCode = 'en';
  sortMenuId = 'sortMenuId' + Math.random().toString(36).substring(2, 9);
  showLangMenu = false;
  clientData: any;

  // Variable to store languages from getLanguages() method
  availableLanguages = new Map<string, string>();
  allowMultipleLanguages: boolean = false;

  constructor(
    public dialog: MatDialog,
    public translationService: TranslationService,
    public session: Session,
    public display: DisplayService,
    private translatePipe : TranslationPipe
  ) {
    super();
    this.development = !environment.production;
    if (this.translationService.isLanguagePreferenceSet && this.translationService.isLanguagePreferenceSet()) {
      this.selectedLanguageCode = sessionStorage.getItem('languagepreference');
    }
  }

  async ngOnInit(): Promise<void> {

    if (this.translationService.isLanguagePreferenceSet && this.translationService.isLanguagePreferenceSet()) {
      this.selectedLanguageCode = sessionStorage.getItem('languagepreference');
    }

    this.appCompany = this.appCompany.replace(
      '#YEAR',
      new Date().getFullYear().toString()
    );
    this.helpUrl = environment.helpUrl;
    this.clientData = JSON.parse(sessionStorage.getItem('clientData') || '{}');
    
    if (this.translationService) {
      try {
       const isFeatureEnabled = await this.translationService.isMultiLanagueFeatureEnabled();
       if(isFeatureEnabled){
        this.allowMultipleLanguages = true;
       }
       else{
        this.allowMultipleLanguages = false;
       }
        if (this.allowMultipleLanguages) {
          await this.loadAvailableLanguages();

          if(this.selectedLanguageCode === 'en' && this.session.user.defaultLanguageCode && this.session.user.defaultLanguageCode !== 'en' && !sessionStorage.getItem('languagepreference')){
            this.selectLanguage(this.session.user.defaultLanguageCode, new Event('click'));
          }
        }
      } catch (error) {
        console.warn('Translation service not available yet:', error);
        // Fallback to old method if new methods don't exist
        await this.getLanguages();
      }
    }
  }

  async getLanguages(): Promise<void> {
    try {
      await this.translationService.getLanguages(this.session.user.contNum);
      const languages = this.translationService.languages();
      // Convert SelectOption[] to Map<string, string> for compatibility
      this.availableLanguages = new Map();
      languages.forEach(lang => {
        this.availableLanguages.set(lang.value, lang.label);
      });
      this.allowMultipleLanguages = this.availableLanguages.size > 1;
    } catch (error) {
      console.error('Error loading languages:', error);
      this.availableLanguages = new Map<string, string>();
      this.allowMultipleLanguages = false;
    }
  }

  getSelectedLanguage() {
    if (this.selectedLanguageCode != undefined && this.selectedLanguageCode != null && this.selectedLanguageCode.length > 1) {
      if (this.selectedLanguageCode.toLowerCase() === 'en') {
        return this.availableLanguages.get(this.selectedLanguageCode);
      }
      else {
        return this.availableLanguages.get(this.selectedLanguageCode);
      }
    }
    else{
      return this.availableLanguages.get('en') || 'en';
    }
  }

  loadAvailableLanguages(): void {
    if (this.translationService.getLanguages && typeof this.translationService.getLanguages === 'function') {
      const contNum = this.clientData?.contNum || 0;
      const languagesObservable = this.translationService.getLanguages(contNum.toString());

      if (languagesObservable && languagesObservable.subscribe) {
        languagesObservable.subscribe({
          next: (languages: Record<string, string>) => {
            var lang = Object.entries(languages);
            this.availableLanguages = new Map(Object.entries(languages));
            this.availableLanguages = new Map(lang);
            if(this.availableLanguages.size > 1) {
              this.allowMultipleLanguages = true;
              if(!sessionStorage.getItem('languagepreference')){
        
                let browserLanguage = navigator.language || navigator.languages?.[0] || 'en';
                browserLanguage = browserLanguage.toLowerCase().startsWith('en') ? 'en' : browserLanguage.toLowerCase().substring(0, 2);
          
                this.selectedLanguageCode = this.availableLanguages.get(browserLanguage) || 'en';
                
                sessionStorage.setItem('languagepreference', browserLanguage);
                window.location.reload();
              }    
              else{
                this.selectedLanguageCode = sessionStorage.getItem('languagepreference');
              }      
            }
          },
          error: (error) => {
            console.error('Error loading available languages:', error);
            // Fallback to old method
            this.availableLanguages = new Map<string, string>();
          }
        });
      } 
    } 
  }

  openSupportDialog(): void {
    const dialogRef = this.dialog.open(SupportDialogComponent, {
      disableClose: true,
    });
    this.subs.sink = dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.dialog.closeAll();
      }
    });
  }

  onLanguageKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toogleLanguage();
    }
  }

  toogleLanguage(): void {
    this.showLangMenu = !this.showLangMenu;
  }

  async selectLanguage(languageCode: string, event: Event): Promise<void> {
    event.preventDefault();
    this.showLangMenu = false;
    
    // Use new translation service methods if available
    if (this.translationService.setDefaultLanguage) {
      await this.translationService.setDefaultLanguage(languageCode);
    }
    
    // Clear translation cache before changing language
    if (this.translationService.clearTranslationCache) {
      this.translationService.clearTranslationCache();
    }
    
    sessionStorage.setItem('languagepreference', languageCode);
    await this.session.setLanguagePreferenceForUser(languageCode);
    this.FeatureLogging('MultiLanguageTranslation', languageCode, 'Footer - Language switch');
    window.location.reload();
  }

  sortByValue = (a: { key: string, value: string }, b: { key: string, value: string }): number => {
    return a.value.localeCompare(b.value);
  }

  @HostListener('document:keydown', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
  if (event.key === 'Escape') {
      if (this.showLangMenu) {
        this.showLangMenu = false;
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const languageButton = target.closest('#language-open');
    const regionalNav = target.closest('#regional-nav');
    // Close the menu if clicking outside both the button and the menu
    if (this.showLangMenu && !languageButton && !regionalNav) {
      this.showLangMenu = false;
    }
  }
}
